import { Footerdemo } from "@/components/ui/footer-section";

function Footer() {
  return <Footerdemo />;
}

export default Footer;
